<div class="ui top fluid attached segment" [hidden]="!currentStep || wizardConfig.isPlugin">
    <zoom-steps [currentStep]="currentStep" [steps]="steps" [metaData]="stepsMetaData"></zoom-steps>
</div>
<div class="ui middle attached segment" [class.borderless]="wizardConfig.isPlugin">
    <div class="ui form main-container" [ngClass]="containerClasses">
        <!-- Dynamic form components are added to this form-host directive -->
        <ng-template form-host></ng-template>
        <wizard-error [error]="errorService.currentError"></wizard-error>
    </div>
</div>
<div class="ui bottom attached segment" [class.borderless]="wizardConfig.isPlugin">
    <wizard-actions
        [currentPage]="currentPage"
        [actions]="actions"
        (onHandleCancel)="handleCancel($event)"
        (onTrackEvent)="handleTrackEvent($event)"
    ></wizard-actions>
</div>
<zoom-steps
    [currentStep]="currentStep"
    [steps]="steps"
    [hidden]="!currentStep || wizardConfig.isPlugin"
    [isBottomPosition]="true"
></zoom-steps>
